import styled from '@emotion/styled'

export const Buttons = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
